import React, { useState } from 'react';
import { generatePath, Link, matchPath, useLocation } from 'react-router-dom';
import Bluebird from 'bluebird';
import { useDispatch } from 'react-redux';
import { Checkbox, FormControlLabel, Dialog, DialogTitle, DialogContent, Typography, Box } from '@mui/material';
import useNotificationService from '../hooks/useNotificationService';
import routes from '../routes';
import { hasRoleInCurrentlySelectedSite } from '../services/auth';
import { Roles } from '../models/roles';
import { updateUser } from '../actions/users';

const PrivacyPolicyReagreement = ({ user }) => {
  const [dialogOpen, setDialogOpen] = useState(true);
  const { addErrorNotification } = useNotificationService();
  const location = useLocation();
  const dispatch = useDispatch();
  const isDonor = hasRoleInCurrentlySelectedSite(user, Roles.DonorLocationAdmin);

  const handleAccept = (event) => {
    if (event.target.checked) {
      return Bluebird.try(() => dispatch(updateUser(user.id, { tos_accepted: true })))
        .then(() => setDialogOpen(false))
        .catch((error) => addErrorNotification(error, error.message));
    }

    return null;
  };

  if (
    matchPath(location.pathname, {
      path: routes.termsOfService,
    })
  ) {
    return null;
  }

  return (
    <Dialog
      open={dialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
    >
      <DialogTitle>Terms of Service</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          We’ve updated our terms of service and our privacy policy! Please review and accept below:
        </Typography>
        <Box mt={1}>
          <FormControlLabel
            label={
              <>
                I agree to the&nbsp;
                <Link
                  target="_blank"
                  to={generatePath(routes.termsOfService, { type: isDonor ? 'food-donor' : 'rescuer' })}
                >
                  Terms of Service and Privacy Policy
                </Link>
                .
              </>
            }
            required
            control={<Checkbox color="secondary" onChange={handleAccept} />}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default PrivacyPolicyReagreement;
